module.exports = __webpack_public_path__ + "static/images/styles/images/reserves/journal/additional-briefing.66f83c28.png";


//////////////////
// WEBPACK FOOTER
// ./styles/images/reserves/journal/additional-briefing.png
// module id = 3727
// module chunks = 11